import React from 'react';
import { CheckCircle2Icon, LockKeyholeIcon, ShieldCheckIcon, SparklesIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { trackMetaEvent } from './MetaPixel';
const checkoutUrl = 'https://megapackrecursosdenivelinicial.impultienda.ar/checkout';
const includedItems = ['Más de 100 planificaciones completas', 'Más de 250 recursos para Nivel Inicial', '4 bonus exclusivos incluidos', 'Acceso inmediato y para siempre'];
export function PlanSelector() {
  return <div className="mx-auto max-w-2xl" data-id="element-93">
      <div className="relative overflow-hidden rounded-[1.6rem] border-4 border-yellow-300 bg-white shadow-2xl" data-id="element-94">
        <div className="bg-gradient-to-r from-orange-500 to-pink-500 px-4 py-3 text-center text-white" data-id="element-95">
          <div className="flex items-center justify-center gap-2 text-sm font-black uppercase tracking-wide" data-id="element-96">
            <SparklesIcon className="h-4 w-4" data-id="element-97" />
            Oferta especial de lanzamiento
            <SparklesIcon className="h-4 w-4" data-id="element-98" />
          </div>
        </div>

        <div className="p-5 sm:p-7" data-id="element-99">
          <div className="text-center" data-id="element-100">
            <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-orange-600" data-id="element-101">
              Una sola compra para todo el año
            </p>
            <h3 className="mt-2 text-3xl font-black tracking-tight text-slate-900 sm:text-4xl" data-id="element-102">
              Mega Pack de Recursos
            </h3>
            <p className="mx-auto mt-2 max-w-lg text-sm leading-relaxed text-slate-600 sm:text-base" data-id="element-103">
              La tranquilidad de tener una biblioteca enorme lista para cuando
              la necesitás, sin volver a resolver todo desde cero.
            </p>
          </div>

          <div className="my-5 flex items-end justify-center gap-3 rounded-2xl bg-orange-50 px-4 py-4" data-id="element-104">
            <div className="pb-1 text-right" data-id="element-105">
              <span className="block text-sm text-slate-400 line-through" data-id="element-106">
                $49.990
              </span>
              <span className="rounded-full bg-pink-100 px-2 py-0.5 text-xs font-black text-pink-600" data-id="element-107">
                AHORRÁS HOY
              </span>
            </div>
            <div data-id="element-108">
              <span className="block text-xs font-bold uppercase tracking-widest text-slate-500" data-id="element-109">
                Hoy por
              </span>
              <span className="bg-gradient-to-r from-orange-500 to-pink-500 bg-clip-text text-5xl font-black leading-none tracking-tight text-transparent sm:text-6xl" data-id="element-110">
                $21.990
              </span>
              <span className="ml-1 text-sm font-black text-orange-600" data-id="element-111">
                ARS
              </span>
            </div>
          </div>

          <ul className="grid gap-2.5 text-left sm:grid-cols-2" data-id="element-112">
            {includedItems.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold leading-snug text-slate-700" data-id="element-113">
                <CheckCircle2Icon className="mt-0.5 h-4 w-4 flex-shrink-0 text-green-600" data-id="element-114" />
                {item}
              </li>)}
          </ul>

          <motion.a href={checkoutUrl} target="_blank" rel="noopener noreferrer" whileTap={{
          scale: 0.98
        }} onClick={() => trackMetaEvent('InitiateCheckout', {
          content_name: 'Mega Pack de Recursos Docentes',
          content_type: 'product',
          value: 21990,
          currency: 'ARS'
        })} className="mt-6 flex w-full items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-yellow-400 to-orange-500 px-4 py-5 text-center text-base font-black text-white shadow-xl shadow-orange-200 transition-transform hover:-translate-y-0.5 sm:text-lg" data-id="element-115">
            <SparklesIcon className="h-5 w-5" data-id="element-116" />
            QUIERO TENER EL AÑO RESUELTO
          </motion.a>

          <div className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs font-medium text-slate-500" data-id="element-117">
            <span className="flex items-center gap-1.5" data-id="element-118">
              <LockKeyholeIcon className="h-3.5 w-3.5" data-id="element-119" /> Pago seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-120">
              <ShieldCheckIcon className="h-3.5 w-3.5" data-id="element-121" /> Acceso automático por
              email
            </span>
          </div>
        </div>
      </div>
    </div>;
}